import React, { useRef } from "react";

function Studio() {
  const sliderRef = useRef(null);

  return (
    <section
      id="studio"
      className="py-16 px-8"
      style={{ backgroundColor: "rgb(1, 35, 38)" }}
    >
      <h2
        className="text-3xl font-bold text-center mb-8"
        style={{ color: "#BFAE99" }}
      >
        O Estúdio
      </h2>

      {/* Descrição */}
      <div className="space-y-6 max-w-4xl mx-auto text-center text-white">
        <p className="text-justify">
          “AJUDAR O PRÓXIMO” – Quando decidimos investir na criação deste
          espaço, o lema sempre foi este. Criar um espaço onde todos se sintam
          melhores do que quando lá entraram pela primeira vez, onde todos
          queiram voltar!
        </p>
        <p className="text-justify">
          No MIND, sabemos que o ambiente que envolve os nossos alunos é muito
          importante para a consistência de treino. Por isso, o nosso espaço foi
          inteiramente desenhado a pensar em si e no seu bem-estar. Num ambiente
          acolhedor e familiar, pode treinar sentindo-se em casa.
        </p>

        {/* Morada */}
        <div className="mt-8">
          <p className="font-bold text-center">Localização:</p>
          <p className="text-justify">
            Rua Abel Salazar, número 2B, Setúbal 2910-372
          </p>
        </div>

        {/* Google Maps */}
        <div className="mt-8">
          <iframe
            title="Localização"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.6519110171365!2d-8.8945691!3d38.5247331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd18a5fdb5f32d35%3A0x394edfc3b7a2d679!2sRua%20Abel%20Salazar%2C%202B%2C%202910-372%20Set%C3%BAbal!5e0!3m2!1spt-PT!2spt!4v1670847574632!5m2!1spt-PT!2spt"
            className="w-full h-80 rounded-lg shadow-md"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Galeria Slider */}
      <div className="mt-16">
        <h3 className="text-2xl text-center text-[#BFAE99] font-semibold mb-6">
          Galeria do Estúdio
        </h3>

        <div
          ref={sliderRef}
          className="flex space-x-4 overflow-x-auto px-4 py-4 cursor-grab active:cursor-grabbing max-w-7xl mx-auto select-none"
          onMouseDown={(e) => {
            const slider = sliderRef.current;
            slider.isDown = true;
            slider.startX = e.pageX - slider.offsetLeft;
            slider.scrollLeftStart = slider.scrollLeft;
          }}
          onMouseLeave={() => {
            const slider = sliderRef.current;
            slider.isDown = false;
          }}
          onMouseUp={() => {
            const slider = sliderRef.current;
            slider.isDown = false;
          }}
          onMouseMove={(e) => {
            const slider = sliderRef.current;
            if (!slider.isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - slider.startX) * 1.5;
            slider.scrollLeft = slider.scrollLeftStart - walk;
          }}
        >
          {[
            "DSC07307.jpg",
            "DSC07309.jpg",
            "DSC07311.jpg",
            "DSC07312.jpg",
            "DSC07313.jpg",
            "DSC07314.jpg",
            "DSC07315.jpg",
            "DSC07316.jpg",
            "DSC07317.jpg",
          ].map((img, idx) => (
            <img
              key={idx}
              src={`/images/studio/${img}`}
              alt={`Foto ${idx + 1}`}
              className="w-80 max-h-[500px] rounded-xl shadow-lg object-contain flex-shrink-0"
              draggable={false}
            />
          ))}
        </div>
      </div>

      {/* Botão de Contacto */}
      <div className="mt-12 text-center w-full">
        <a
          href="/contact"
          className="inline-block px-6 py-3 bg-[#BFAE99] text-[#012326] font-semibold rounded-lg hover:bg-white transition-colors duration-300"
        >
          Contacte-nos!
        </a>
      </div>
    </section>
  );
}

export default Studio;
